import React, { useState, useEffect } from "react";
import { Slider } from "../../../components/slider/slider";
import { SwiperSlide } from "swiper/react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../../AppContext";
import Counter from "../../../components/increaser-decreaser/counter";
import {
  cardMachines,
  CardMachine,
  ProductTypes,
  Routing,
} from "../../../file.interface";
import { formatAsEuro } from "../../../helpers/helpers";
import { RadioContractDuration } from "../../../components/radio-buttons/radios-contract-duration";
import AccessoriesDynamicTable from "../../../components/dynamic-table/terminals-dynamic-table";

const TerminalsScreen2: React.FC = () => {
  //
  const navigate = useNavigate();
  const {
    selectedContractDuration,
    flowCardMachines,
    flowDevices,
    dispatch,
    sites,
    selectedSiteFlow,
    isNewSite,
    routing,
  } = useAppContext();

  const handleNextStep = () => {
    navigate("/accessories-screen-3");
  };

  return (
    <div className="screen-container">
      {(routing === Routing.Epos || routing === Routing.EposByIndustry) &&
      flowDevices.length ? (
        <>
          <h3 className="title-screen">
            Do you need additional card machines?
          </h3>
          <h4 className="subtitle-screen">
            You already have {flowDevices.length} card machine(s) included in
            your EPOS system
          </h4>
        </>
      ) : (
        <>
          <h3 className="title-screen">Discover Your Monthly Costs</h3>
          <h4 className="subtitle-screen">
            How many card machines do you need?
          </h4>
        </>
      )}

      <div style={{ maxWidth: 700, width: "100%" }}>
        <Slider
          breakpoints={{
            1024: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            320: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
          }}
        >
          {cardMachines?.map((product, index) => (
            <SwiperSlide key={index + product.id}>
              <div className="product-card">
                <div
                  style={{ textAlign: "center" }}
                  className="image-container"
                >
                  <img
                    src={product.imageUrl}
                    alt={product.name}
                    style={{ width: "100%", maxWidth: 220 }}
                  />
                </div>
                <div style={{ padding: 20 }}>
                  <h3 className="card-title">{product.name}</h3>
                  <Counter product={product} flow={flowCardMachines} />
                  <p className="price-by-unit">
                    Price by unit:{" "}
                    {formatAsEuro(product.prices[selectedContractDuration])}{" "}
                    monthly
                  </p>
                  <p>{product.description}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Slider>
      </div>
      {flowCardMachines.length > 0 && (
        <>
          {/* <h3 className="title-screen">Summary</h3> */}
          <RadioContractDuration />
          <AccessoriesDynamicTable />
        </>
      )}

      {(flowDevices.length > 0 || flowCardMachines.length > 0) && (
        <div className="buttons-container">
          <button
            className="app-button previous-button"
            onClick={() => navigate("/devices-screen-1")}
          >
            Previous
          </button>
          <button
            className={`app-button next-button`}
            onClick={() => handleNextStep()}
          >
            {flowDevices.length > 0 && flowCardMachines.length === 0
              ? "Skip"
              : "Next"}
          </button>
        </div>
      )}
    </div>
  );
};

export default TerminalsScreen2;
